module.exports = __webpack_public_path__ + "static/media/genesis.cd8f979c.png";


//////////////////
// WEBPACK FOOTER
// ./src/new_components/generic/png/genesis.png
// module id = 7367
// module chunks = 4